<template>
    <modal
        name="show-duplicity-modal"
        class="modal--translation modal--hide-on-loading"
        v-cloak
        width="768px"
        height="auto"
        :scrollable="false"
        :adaptive="false"
        :pivot-y="0.25"
    >
        <div class="modal-header m-0">
            <button @click="closeModal()" type="button" class="close close-modal mr-2">
                <i class="fal fa-fw fa-times"></i>
            </button>

            <h5 class="modal-title m-0">
                <i class="fa fa-exclamation-triangle mr-2"></i> {{ trans.title }}
            </h5>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col h-100 p-0 pb-4">
                    <div class="d-flex justify-content-center h-100 flex-column">
                        <h6><b>{{ trans.existing }}</b></h6>
                        <p class="subtitle m-0">{{ duplicityTemplate.title }}</p>
                        <a
                            class="link"
                            :href="duplicityTemplate.resource_url + '/edit'"
                            target="_blank"
                        >
                            <i class="fa fa-edit"></i> {{ trans.editing_btn }}
                        </a>
                    </div>
                </div>
                <div class="col h-100 p-0 pb-4">
                    <div class="d-flex justify-content-center h-100 flex-column">
                        <h6><b>{{ trans.editing }}</b></h6>
                        <p class="subtitle m-0">{{ editingTemplate.title }}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col h-100 p-0 w-50 pb-4">
                    <div class="d-flex justify-content-center h-100 flex-column">
                        <b>{{ trans.contract_types }}</b>

                        <div>
                            <p v-for="(cct, index) in duplicityTemplate.company_contract_types" class="m-0 existing-item">
                                {{ cct.name }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col h-100 p-0 w-50 pb-4">
                    <div class="d-flex justify-content-center h-100 flex-column">
                        <b>{{ trans.contract_types }}</b>

                        <div>
                            <p
                                v-for="(cct, index) in editingTemplate.company_contract_types"
                                class="m-0 editing-item"
                                :class="areCollectionsSame(duplicityTemplate.company_contract_types, editingTemplate.company_contract_types) ? '' : highlightItem(duplicityTemplate.company_contract_types, cct.id)"
                            >
                                {{ cct.name }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col h-100 p-0 pb-4">
                    <div class="d-flex justify-content-center h-100 flex-column">
                        <b>{{ trans.positions }}</b>

                        <div>
                            <p v-for="(pos, index) in duplicityTemplate.positions" class="m-0 existing-item">
                                {{ pos.title }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col h-100 p-0 pb-4">
                    <div class="d-flex justify-content-center h-100 flex-column">
                        <b>{{ trans.positions }}</b>

                        <div>
                            <p
                                v-for="(pos, index) in editingTemplate.positions"
                                class="m-0 editing-item"
                                :class="areCollectionsSame(duplicityTemplate.positions, editingTemplate.positions) ? '' : highlightItem(duplicityTemplate.positions, pos.id)"
                            >
                                {{ pos.title }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col h-100 p-0 pb-4">
                    <div class="d-flex justify-content-center h-100 flex-column">
                        <b>{{ trans.restaurants }}</b>

                        <div>
                            <p v-for="(res, index) in duplicityTemplate.restaurants" class="m-0 existing-item">
                                {{ res.title }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col h-100 p-0 pb-4">
                    <div class="d-flex justify-content-center h-100 flex-column">
                        <b>{{ trans.restaurants }}</b>

                        <div>
                            <p
                                v-for="(res, index) in editingTemplate.restaurants"
                                class="m-0 editing-item"
                                :class="areCollectionsSame(duplicityTemplate.restaurants, editingTemplate.restaurants) ? '' : highlightItem(duplicityTemplate.restaurants, res.id)"
                            >
                                {{ res.title }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer flex justify-content-center">
            <b-button @click="closeModal()" type="button" variant="danger">
                <i class="fa fa-times"></i> {{ trans.close }}
            </b-button>
        </div>
    </modal>
</template>


<script>
export default {
    props: {
        'editingTemplate': {
            type: Object
        },
        'duplicityTemplate': {
            type: Object
        },
        'trans': {
            type: Object
        }
    },

    methods: {
        closeModal() {
            this.$modal.hide('show-duplicity-modal');
        },

        highlightItem(dcct, itemId) {
            if(dcct){
                let isContractIdInArray = dcct.some((contract) => contract.id === itemId)
                return isContractIdInArray ? 'highlight' : '';
            }
        },

        areCollectionsSame(array1, array2) {
            return (array1 && array2) ? array1.every((item1) => {
                return array2.some((item2) => item1.id === item2.id);
            }) && array1.length === array2.length : false
        }
    },
};
</script>

<style lang="scss" scoped>
.modal-header {
    padding: 0;
    margin: 0 0 35px;
    border-bottom: 0;
}

h6 {
    font-size: 14px;
}

.modal-footer {
    padding: 0;
    margin-top: 18px;
    border: 0;
}

.form-group {
    margin-bottom: 3px;
}

.modal-body {
    font-size: 14px;
}

.subtitle {
    font-size: 12px;
    color: #888;
    font-style: italic;
}

.link {
    font-size: 12px;
    color: #4273FA;
}

.editing-item {
    color: white;
    display: inline-block;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 0.875rem;
    background-color: #4273FA;
    border-color: #4273FA;
    margin: 5px !important;
    padding: 0.25rem 0.5rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}

.existing-item {
    color: white;
    display: inline-block;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 0.875rem;
    background-color: #888;
    border-color: #888;
    margin: 5px !important;
    padding: 0.25rem 0.5rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}

.highlight {
    background-color: #FE3F61 !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/document-template/modals/ShowDuplicityModal.vue